import { observer } from "mobx-react-lite";
import React from "react";
import { classNames } from "../../helpers";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI Imports
import { FormControl, Select, MenuItem } from "@mui/material";

function iconStyles(current) {
    return classNames(
        current
            ? "text-gray-500 group-hover:text-gray-500"
            : "text-gray-400 group-hover:text-gray-500",
        "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
    );
}

const C3Items = observer(() => {
    const { t } = useTranslation("constituency_command_center");
    const navigate = useNavigate();

    const navigation = [
        {
            name: t("demographics"),
            href: `demographics`,
            icon: "demographics",
            current: false,
        },
        {
            name: t("party_workers"),
            href: `partyworkers`,
            icon: "partyworkers",
            current: false,
        },
        {
            name: t("historical"),
            href: `historical`,
            icon: "historical",
            current: false,
        },
        // {
        //   name: t("beneficiaries"),
        //   href: `beneficiaries`,
        //   icon: "beneficiaries",
        //   current: false,
        // },
        // { name: "Grievance", href: `grievance`, icon: "Grievance", current: false },
        {
            name: t("service_request"),
            href: `service_request`,
            icon: "servicerequest",
            current: false,
        },
        {
            name: "Project Works",
            href: `project_works`,
            icon: "projectworks",
            current: false,
        },
        {
            name: "Organizational structure",
            href: `organizational_structure`,
            icon: "organizational_structure",
            current: false,
        },
    ];

    return (
        <>
            {/* ---------- MOBILE SELECT (MUI) ---------- */}
            <div className="my-2 sm:hidden">
                <FormControl fullWidth size="small">
                    <Select
                        defaultValue={navigation[0].name}
                        onChange={(eve) => {
                            const selected = eve.target.value;
                            const obj = navigation.find(
                                (x) => x.name === selected
                            );
                            if (obj) navigate(obj.href);
                        }}
                        className="py-1"
                    >
                        {navigation.map((tab) => (
                            <MenuItem key={tab.name} value={tab.name}>
                                {tab.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {/* ---------- DESKTOP SIDE MENU ---------- */}
            <aside className="hidden bg-gray-100 px-2 py-6 sm:block sm:px-6 lg:col-span-2 lg:px-0 lg:py-0">
                <nav className="space-y-1">
                    {navigation.map((item) => (
                        <NavLink
                            key={item.href}
                            to={item.href}
                            className={(props) =>
                                classNames(
                                    props.isActive
                                        ? "bg-white text-gray-700 hover:bg-gray-200"
                                        : "text-gray-700 hover:bg-white",
                                    "group flex items-center px-3 py-2 font-medium"
                                )
                            }
                            aria-current={item.current ? "page" : undefined}
                        >
                            {(() => {
                                switch (item.icon) {
                                    case "demographics":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-id-card text-xl`}
                                            />
                                        );
                                    case "historical":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-rectangle-history text-xl`}
                                            />
                                        );
                                    case "beneficiaries":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-handshake text-xl`}
                                            />
                                        );
                                    case "partyworkers":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-person text-2xl`}
                                            />
                                        );
                                    case "Grievance":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-users text-xl`}
                                            />
                                        );
                                    case "servicerequest":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-gear text-xl`}
                                            />
                                        );
                                    case "projectworks":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-users text-xl`}
                                            />
                                        );
                                    case "organizational_structure":
                                        return (
                                            <i
                                                className={`${iconStyles(
                                                    item.current
                                                )} fa-solid fa-sitemap text-xl`}
                                            />
                                        );
                                    default:
                                        return null;
                                }
                            })()}
                            <span className="truncate">{item.name}</span>
                        </NavLink>
                    ))}
                </nav>
            </aside>
        </>
    );
});

export default C3Items;
